<!-- 合伙人指引 -->
<template>
  <div
    class="blue-container guide-container"
  >
    <div class="invitate-box">
      <van-image
        width="100%"
        fit="contain"
        :src="inviteFlowChart"
      />
      <GoldTitle
        context="icon11yaoqingfangshi"
        extraClass="invite"
      />
    </div>
  </div>
</template>

<script>
import GoldTitle from '@/components/goldTitle'
import inviteFlowChart from '@/assets/images/home/inviteFlowChart.png'
export default {
  name: 'guide',
  components: { GoldTitle },
  data() {
    return {
      inviteFlowChart
    }
  }
}
</script>

<style lang="less" scpoed>
  .invitate-box {
    display: flex;
    padding: 60px 8px 23px;
    margin-bottom: 32px;
    position: relative;
    background: #282830;
  }
  .guide-container {
    padding: 32px 16px 0;
    box-sizing: border-box;
    .invitate-box {
      margin: 0;
    }
  }
</style>
